import { render } from "./TrainingRncpAccordionClassificationComponent.vue?vue&type=template&id=65f0a3ec"
import script from "./TrainingRncpAccordionClassificationComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpAccordionClassificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__